import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  connectShopifyStore,
} from 'redux/integrations/actions';

import { withRouter } from 'react-router-dom';

import CommonLoader from 'components/common/CommonLoader';

class ShopifyConnectPage extends Component {
  static propTypes = {
    connectShopifyStore: PropTypes.func.isRequired,
    location: PropTypes.object,
    history: PropTypes.object,
  };

  static defaultProps = {
    location: null,
    history: null,
  };

  componentDidMount() {
    this._connectShopifyStore();
  }

  _connectShopifyStore = () => {
    const connectionData = this.props.location.search.split('&');
    const code = connectionData[0].replace('?code=', '');
    const hmac = connectionData[1].replace('hmac=', '');
    const shop = connectionData[2].replace('shop=', '');
    this.props.connectShopifyStore(code, hmac, shop);
    setTimeout(() => {
      this.props.history.push('/integrations/shopify');
    }, 4000);
  };

  render() {
    return (
      <CommonLoader
        active
        text="Shopify Integration..."
      />
    );
  }
}

const mapStateToProps = state => (
  {}
);

export default connect(
  mapStateToProps,
  {
    connectShopifyStore,
  },
)(withRouter(ShopifyConnectPage));
